/**
 * EmbedBridge: wires lib/embedBridge into the router and the session.
 * Renders nothing. Outside a frame it does nothing at all.
 */
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { announceNavigated, announceReady, isEmbedded, requestParentSignIn, startEmbedBridge } from "../lib/embedBridge";

export default function EmbedBridge() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const live = useRef({ user, loading, path: location.pathname });
  live.current = { user, loading, path: location.pathname };

  useEffect(() => startEmbedBridge({
    navigate: (path) => navigate(path),
    current: () => live.current.path,
    authState: () => (live.current.loading ? "loading" : live.current.user ? "yes" : "no"),
  }), [navigate]);

  useEffect(() => {
    if (!isEmbedded() || loading) return;
    if (user) announceReady(live.current.path);
    else requestParentSignIn(live.current.path);
  }, [user, loading]);

  useEffect(() => {
    if (isEmbedded() && user) announceNavigated(location.pathname);
  }, [location.pathname, user]);

  return null;
}
